import { useMemo, useState } from "react"
import { Col, Row } from "reactstrap"
import { OpportunitiesResult } from "models/opportunity-dashboard"
import StageSummaryTable from "./stage-summary-table"
import OpportunityListTable from "./opportunity-list-table"
import SalesFunnelChart from "./sales-funnel-chart"

interface OpportunitiesTabProps {
    data: OpportunitiesResult
}

// Open stages and Won on the left, sales funnel on the right, the opportunity list below.
// Clicking a stage filters the list to it.
const OpportunitiesTab = ({ data }: OpportunitiesTabProps) => {
    const [selectedStage, setSelectedStage] = useState<string | null>(null)

    const rows = useMemo(
        () => selectedStage ? data.rows.filter(r => r.stage === selectedStage) : data.rows,
        [data.rows, selectedStage],
    )

    return <div className="d-flex flex-column gap-4">
        <Row className="g-4">
            <Col xl={8}>
                <div className="d-flex flex-column gap-4">
                    <div>
                        <h5>Stages</h5>
                        <StageSummaryTable rows={data.stages} selectedStage={selectedStage} onSelectStage={setSelectedStage} />
                    </div>
                    <div>
                        <h5>Won</h5>
                        <StageSummaryTable rows={data.won} selectedStage={selectedStage} onSelectStage={setSelectedStage} />
                    </div>
                </div>
            </Col>
            <Col xl={4}>
                <div className="section-container">
                    <h5 className="mb-3">Sales Funnel</h5>
                    <SalesFunnelChart stages={data.funnel} />
                </div>
            </Col>
        </Row>
        <div>
            <div className="d-flex align-items-center gap-2 mb-2">
                <h5 className="mb-0">Opportunities</h5>
                {selectedStage && <button type="button" className="btn btn-sm btn-light" onClick={() => setSelectedStage(null)}>
                    {selectedStage} <i className="mdi mdi-close" />
                </button>}
            </div>
            <OpportunityListTable rows={rows} />
        </div>
    </div>
}

export default OpportunitiesTab
